/* eslint-disable no-comments/disallowComments */
import { SelectOption } from '../models';

export const TimeZones: SelectOption[] = [
  { value: 'America/New_York', label: '(GMT -05:00) Eastern Time (ET)' },
  { value: 'America/Chicago', label: '(GMT -06:00) Central Time (CT)' },
  { value: 'America/Denver', label: '(GMT -07:00) Mountain Time (MT)' },
  { value: 'America/Los_Angeles', label: '(GMT -08:00) Pacific Time (PT)' },
  { value: 'America/Anchorage', label: '(GMT -09:00) Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: '(GMT -10:00) Hawaii-Aleutian Time (HAST)' },
];

export const SchortTimeZones: SelectOption[] = [
  { value: 'America/New_York', label: 'ET' },
  { value: 'America/Chicago', label: 'CT' },
  { value: 'America/Denver', label: 'MT' },
  { value: 'America/Los_Angeles', label: 'PT' },
  { value: 'America/Anchorage', label: 'AKT' },
  { value: 'Pacific/Honolulu', label: 'HAST' },
];
